import { useState, useEffect } from 'react';

import fetchExpresso from 'utility/fetchExpresso';

export default function useExpresso(endpoint, method, headers, body, dependency) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const options =
        method && method === 'POST'
            ? { method, headers, body }
            : undefined;

    // useEffect will only run again if a value in this array changes
    // pass an empty array if you only want the effect to run once
    const dependencyArray = Array.isArray(dependency) ? dependency : [];

    useEffect(() => {
        let mounted = true;

        if (!loading) {
            setLoading(true);
        }
        if (error) {
            setError(false);
        }

        fetchExpresso(endpoint, options)
            .then((res) => res.json())
            .then((data) => {
                if (mounted) {
                    if (data.err === true) {
                        setError(true);
                    } else {
                        setData(data);
                    }
                    setLoading(false);
                }
            })
            .catch((error) => {
                if (mounted) {
                    setError(error);
                    setLoading(false);
                }
            });

        const cleanup = () => {
            mounted = false;
        };
        return cleanup;

        // eslint-disable-next-line
    }, dependencyArray);

    return [data, loading, error];
}
